<div>
  <ng-container *ngIf="config.data.results.length === 0">
    No Findings
  </ng-container>
  <div *ngFor="let result of config.data.results">
    {{format(result.condition.operator, result.condition.path, result.condition.value, result.result)}}
  </div>
</div>
<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
  @if (config.data.allowDismiss){
    <button mat-raised-button (click)="1">Resolved</button>
  }
  <button mat-raised-button (click)="onClose()">Close</button>
</div>
